export default __webpack_public_path__ + "static/media/backWhite.bd76f771.svg";